/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_BusinessInputs */

const en_nav_business = /** @type {(inputs: Nav_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business`)
};

const es_nav_business = /** @type {(inputs: Nav_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empresas`)
};

/**
* | output |
* | --- |
* | "Business" |
*
* @param {Nav_BusinessInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_business = /** @type {((inputs?: Nav_BusinessInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_BusinessInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_business(inputs)
	return en_nav_business(inputs)
});